import { useMemo, useState } from 'react'
import { useDebounce } from 'use-debounce'
import { INPUT_CHANGE_WAIT } from 'common/input/constants'

import { search } from './search'

export const useSearchField = <T extends { [key: string]: any }>(
  data: T[],
  index: string | string[],
) => {
  const [query, setQuery] = useState('')
  const [value] = useDebounce(query, INPUT_CHANGE_WAIT)
  const filtered = useMemo(() => search(data, index, value), [data, index, value])

  return {
    query,
    setQuery,
    data: filtered,
  }
}
